import '../style/city-item.scss'
export default {
  functional: true,
  render (h, context) {
    const props = context.props
    const type = props.type
    const isLabel = type === '_label'
    const className = {
      'kye-area-city-item': true,
      'hot-item': type === 'hot-item',
      'bread-item': type === 'bread-item',
      'city-label': isLabel,
      'selected': props.isSelected,
    }
    // 使用简称
    const shortName = props.item.shortName || props.item.adminName
    const name = isLabel ? shortName + '：' : shortName
    return <div class={className} on-click={() => props.handleClickEvent(props)}>{name}</div>
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/components/city-item.js